import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, Zap, Shield, Users, MessageSquare, BookOpen, LogIn } from 'lucide-react';

const TASK_ICONS = {
  core: Zap,
  behavioral: Shield,
  engagement: BookOpen,
  trust: Users,
  financial: Zap,
};

const CATEGORY_COLORS = {
  core: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-l-blue-400' },
  behavioral: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-l-emerald-400' },
  engagement: { bg: 'bg-violet-50', text: 'text-violet-600', border: 'border-l-violet-400' },
  trust: { bg: 'bg-amber-50', text: 'text-amber-600', border: 'border-l-amber-400' },
  financial: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-l-emerald-500' },
};

const PointsHistory = ({ transactions }) => {
  if (!transactions || transactions.length === 0) {
    return (
      <Card className="glass-card" data-testid="points-history-empty">
        <CardContent className="p-8 text-center">
          <Clock size={36} className="mx-auto text-slate-300 mb-2" />
          <p className="text-sm text-slate-500">No point activity yet. Start earning!</p>
        </CardContent>
      </Card>
    );
  }

  const formatTime = (dateStr) => {
    const d = new Date(dateStr);
    const now = new Date();
    const diff = now - d;
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `${days}d ago`;
    return d.toLocaleDateString('en-NG', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="space-y-2" data-testid="points-history">
      {transactions.map((txn) => {
        const colors = CATEGORY_COLORS[txn.category] || CATEGORY_COLORS.core;
        const Icon = TASK_ICONS[txn.category] || Zap;
        return (
          <Card key={txn.id} className={`glass-card border-l-4 ${colors.border}`}>
            <CardContent className="p-3 flex items-center gap-3">
              <div className={`p-2 rounded-lg ${colors.bg}`}>
                <Icon size={16} className={colors.text} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-slate-800 truncate">{txn.label}</p>
                <p className="text-[10px] text-slate-400">{formatTime(txn.created_at)}</p>
              </div>
              <span className="text-sm font-black text-emerald-600 flex-shrink-0">+{txn.points}</span>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default PointsHistory;
